import { atom, RecoilState } from "recoil";
import { recoilPersist } from 'recoil-persist';

const { persistAtom } = recoilPersist();

export const ScorecardAtom: RecoilState<{scorecardId: string}> = atom<{scorecardId: string}>({
    key: 'ScorecardAtom',
    default: {
        scorecardId: ""
    } as {scorecardId: string},
    effects_UNSTABLE : [persistAtom]
});

